import { sendSuccessNotice, sendErrorNotice, getCurrentTime, refreshResource } from '@/commons/utils';
import { request_detail, request_list, update_detail, create_detail, remove_detail, export_list } from '@/commons/hpod';
import configs from '@/configs'
import Vue from 'vue';
import moment from 'moment';
var FileSaver = require('file-saver');
const endpoint = 'customers'

// initial state
const state = {
    loading: false,
    all: {},
    master: {},
    selected: {
        ID: 0
    }
};

// getters
const getters = {};

// actions
const actions = {
    exportCustomerList({ commit }, param) {
        return new Promise((resolve) => {
            commit("setLoading", { loading: true });
            export_list(endpoint, res => {
                commit("setLoading", { loading: false });
                const disposition = (res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])) || '';
                const matched = disposition.match(/filename="?([^"]+)"?/i);
                let fileName = matched && matched[1] ? matched[1] : `DanhSachKhachHang_${moment().format('YYYYMMDDHHmmss')}.xlsx`;
                var blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
                FileSaver.saveAs(blob, fileName);
                sendSuccessNotice('Xuất file excel thành công.');
                resolve(res);
            }, Vue.http, param, this.state.authentication.token, 'export');
        });
    },
    getCustomerList({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list(endpoint, data => {
            if(param.is_master) {
                commit('setMasterList', data);
            }
            else {
                commit('setCustomerList', data);
            }
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getCustomerDetail({ commit }, payload) {
        const id = typeof payload === 'object' ? payload.id : payload;
        const onError = typeof payload === 'object' ? payload.onError : null;
        const onSuccess = typeof payload === 'object' ? payload.onSuccess : null;
        commit("setLoading", { loading: true });
        request_detail(endpoint, data => {
            commit('setCustomerDetail', data);
            commit("setLoading", { loading: false });
            if (onSuccess) {
                onSuccess(data);
            }
        }, Vue.http, id, this.state.authentication.token, null, err => {
            commit("setLoading", { loading: false });
            if (onError) {
                onError(err);
            }
        });
    },
    removeCustomerDetail({ commit }, id) {
        commit("setLoading", { loading: true });
        remove_detail(endpoint, res => {
            if (res.data.status === false) {
                sendErrorNotice('Không thể xóa khách hàng.')
            }
            else {
                sendSuccessNotice('Đã xóa khách hàng thành công.')
                refreshResource();
            }
            commit("setLoading", { loading: false });
        }, Vue.http, id, this.state.authentication.token);
    },
    setCustomerDetail({ commit }, {data, id, resetPwd, notify}) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                data.ModifiedDate = getCurrentTime().format(configs.SQL_DATE_FORMAT);
                data.ModifiedBy = this.state.authentication.user.userid;
                commit("setLoading", { loading: true });
                if(id > 0) {
                    delete data.CreatedDate;
                    delete data.Createdby;
                    update_detail(endpoint, res => {
                        if (res.data.status === 'fail') {
                            sendErrorNotice('Không thể cập nhật khách hàng.')
                            reject(res);
                        }
                        else if(resetPwd) {
                            sendSuccessNotice(notify)
                            resolve(res)
                        }
                        else {
                            sendSuccessNotice('Cập nhật khách hàng thành công.')
                            resolve(res)
                            refreshResource();
                        }
                        commit("setLoading", { loading: false });
                    }, Vue.http, data, id, this.state.authentication.token);
                }
                else {
                    // data.CreatedDate = getCurrentTime().format(configs.SQL_DATE_FORMAT);
                    data.Createdby = this.state.authentication.user.userid;
                    create_detail(endpoint, res => {
                        if (res.data.status === 'fail') {
                            sendErrorNotice('Không thể thêm mới khách hàng.')
                            reject(res);
                        }
                        else {
                            sendSuccessNotice('Thêm mới khách hàng thành công.');
                            resolve(res)
                            refreshResource();
                        }
                        commit("setLoading", { loading: false });
                    }, Vue.http, data, this.state.authentication.token);
                }
            }, 100)
        })
    },
};

// mutations
const mutations = {
    setCustomerList(state, data) {
        state.all = data;
    },
    setMasterList(state, data) {
        state.master = data;
    },
    setCustomerDetail(state, item) {
        state.selected = item.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
